import React, { useState } from 'react';

import { svg } from '../assets/svg';
import { components } from '../components';
import FallBackImage from '../components/FallBackImage';
import { hooks } from '../hooks';
import { Routes } from '../routes';
import { actions } from '../store/actions';
import { DishType } from '../types';
import { getItemFromLocalStorage } from '../utils/getItemFromLocalStorage';

export const Dish: React.FC = () => {
  const navigate = hooks.useNavigate();
  const dispatch = hooks.useDispatch();
  const location = hooks.useLocation();
  

  const dish: DishType = location.state.dish;
  const [isFullPrice, setIsFullPrice] = useState(true);
  const [opacity, setOpacity] = useState<number>(0);
  
  const {getDishQty} = hooks.useCartHandler();
  const {addToWishlist, removeFromWishlist, ifInWishlist} =
  hooks.useWishlistHandler();
  
  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);
  
  const MENU_CONFIG = getItemFromLocalStorage("menuConfiguration");
  
  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showGoBack={true}
        showBasket={true}
      />
    );
  };
    
  const renderImage = (): JSX.Element => {
    return (
      <section style={{
        position: 'relative',
        marginBottom: 0,
        backgroundColor: '#ffffff',
      }}>
        <div style={{
          width: '100%',
          height: '320px',
          position: 'relative',
          overflow: 'hidden',
          backgroundColor: '#f5f7fa',
        }}>
          {dish.image ? (
            <img
              src={dish.image}
              alt={dish.name}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center',
              }}
            />
          ) : (
            <FallBackImage name={dish.name} />
          )}
          
          {/* Top Overlay - Badges and Wishlist */}
          <div style={{
            position: 'absolute',
            top: 16,
            left: 16,
            right: 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            zIndex: 3,
          }}>
            {/* Left Side - Dietary and Chef Special */}
            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
              {/* Dietary Badge */}
              <div style={{
                padding: '3px',
                backgroundColor: 'rgba(255, 255, 255, 0.98)',
                borderRadius: '4px',
                border: dish.category === 'Veg' ? '1.5px solid #2ecc71' : '1.5px solid #e74c3c',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                width: 28,
                height: 28,
              }}>
                {dish.category === 'Veg' ? (
                  <div style={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#ffffff',
                    borderRadius: '2px',
                    border: '2px solid #2ecc71',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <div style={{
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#2ecc71',
                    }} />
                  </div>
                ) : (
                  <div style={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#ffffff',
                    borderRadius: '2px',
                    border: '2px solid #e74c3c',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative' as const,
                  }}>
                    <div style={{
                      width: 0,
                      height: 0,
                      borderLeft: '4px solid transparent',
                      borderRight: '4px solid transparent',
                      borderTop: '7px solid #e74c3c',
                    }} />
                  </div>
                )}
              </div>
              
              {/* Chef Special Badge */}
              {dish.isChefSpecial && (
                <div style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.98)',
                  borderRadius: '8px',
                  padding: '6px 12px',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                }}>
                  <img
                    alt="Chef Special"
                    src={require('../assets/Filters/chef-hat.png')}
                    style={{
                      width: 20,
                      height: 'auto',
                    }}
                  />
                  <span style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: '#fb551a',
                    fontFamily: 'DM Sans, sans-serif',
                  }}>
                    Chef Special
                  </span>
                </div>
              )}
            </div>
            
            {/* Right Side - Wishlist and Full/Half Toggle */}
            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
              {/* Full/Half Toggle */}
              {dish.halfPrice !== 0 && dish.halfPrice !== null && dish.availability && (
                <div
                  style={{
                    background: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(8px)',
                    borderRadius: '20px',
                    padding: '4px 8px',
                    fontSize: 11,
                    fontWeight: 600,
                    color: '#333',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    transition: 'all 0.2s ease',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsFullPrice(!isFullPrice);
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 1)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.95)';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.12)';
                  }}
                >
                  <span
                    style={{
                      fontSize: 10,
                      fontWeight: !isFullPrice ? 700 : 500,
                      color: !isFullPrice ? 'var(--main-turquoise)' : '#666',
                    }}
                  >
                    Half
                  </span>
                  <div
                    style={{
                      width: 30,
                      height: 16,
                      borderRadius: 20,
                      background: isFullPrice ? 'var(--main-turquoise)' : '#e0e0e0',
                      position: 'relative' as const,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: isFullPrice ? 'flex-end' : 'flex-start',
                      padding: '2px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                    }}
                  >
                    <div
                      style={{
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        background: 'white',
                        transition: 'transform 0.3s ease',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                      }}
                    />
                  </div>
                  <span
                    style={{
                      fontSize: 10,
                      fontWeight: isFullPrice ? 700 : 500,
                      color: isFullPrice ? 'var(--main-turquoise)' : '#666',
                    }}
                  >
                    Full
                  </span>
                </div>
              )}
              
              {/* Wishlist Button */}
              {MENU_CONFIG?.isOrderFromAppSupported && (
                <button
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(8px)',
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
                    transition: 'all 0.2s ease',
                  }}
                  onClick={(event) => {
                    ifInWishlist(dish.id ?? 0)
                      ? removeFromWishlist(dish, event)
                      : addToWishlist(dish, event);
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 1)';
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.95)';
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.12)';
                  }}
                >
                  <svg.HeartSvg dish={dish} />
                </button>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  };

  const renderDetails = (): JSX.Element => {
    return (
      <section style={{
        padding: '24px 20px',
        backgroundColor: '#ffffff',
        marginBottom: 12,
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: 12,
          gap: 12,
        }}>
          <h3 style={{
            fontFamily: 'DM Sans, sans-serif',
            fontSize: 24,
            fontWeight: 700,
            color: '#2d3436',
            margin: 0,
            textTransform: 'capitalize',
            flex: 1,
            lineHeight: 1.3,
          }}>
            {dish.name}
          </h3>
          
          {MENU_CONFIG?.isInfoSupported && dish.kcal && (
            <span style={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 14,
              fontWeight: 500,
              color: '#636e72',
              whiteSpace: 'nowrap',
            }}>
              {dish.kcal} kcal
            </span>
          )}
        </div>
        
        {MENU_CONFIG?.isInfoSupported && dish.description && (
          <p style={{
            fontFamily: 'DM Sans, sans-serif',
            fontSize: 15,
            fontWeight: 400,
            color: '#636e72',
            lineHeight: 1.6,
            margin: 0,
          }}>
            {dish.description}
          </p>
        )}
      </section>
    );
  };

  const renderPriceAndActions = (): JSX.Element => {
    const currentPrice = isFullPrice ? dish.price : (dish.halfPrice || 0);
    const quantity = getDishQty(dish.id ?? 0, isFullPrice);
    
    return (
      <section style={{
        padding: '20px',
        backgroundColor: '#ffffff',
        borderTop: '1px solid #e9ecef',
        position: 'sticky' as const,
        bottom: 0,
        zIndex: 10,
        boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.05)',
      }}>
        {/* Price Display */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
        }}>
          <div>
            <div style={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 28,
              fontWeight: 700,
              color: 'var(--main-turquoise)',
              marginBottom: 4,
            }}>
              ₹{currentPrice}
            </div>
            {dish.halfPrice !== 0 && dish.halfPrice !== null && (
              <div style={{
                fontFamily: 'DM Sans, sans-serif',
                fontSize: 12,
                fontWeight: 500,
                color: '#95a5a6',
              }}>
                {isFullPrice ? `Half: ₹${dish.halfPrice}` : `Full: ₹${dish.price}`}
              </div>
            )}
          </div>
          
          {/* Quantity Controls */}
          {MENU_CONFIG?.isAddtoCartEnabled && dish.availability && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              backgroundColor: '#f8f9fa',
              borderRadius: 12,
              padding: '4px',
            }}>
              <button
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  backgroundColor: '#ffffff',
                  border: '1.5px solid var(--main-turquoise)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: quantity > 0 ? 'pointer' : 'not-allowed',
                  opacity: quantity > 0 ? 1 : 0.5,
                  transition: 'all 0.2s ease',
                }}
                onClick={() => {
                  dispatch(actions.removeFromCart({ ...dish, isFullPrice }));
                }}
                disabled={quantity === 0 || !dish.availability}
                onMouseEnter={(e) => {
                  if (quantity > 0) {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 176, 185, 0.3)';
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <svg.MinusSvg />
              </button>
              
              <span style={{
                fontFamily: 'DM Sans, sans-serif',
                fontSize: 16,
                fontWeight: 700,
                color: '#2d3436',
                minWidth: 24,
                textAlign: 'center',
              }}>
                {quantity}
              </span>
              
              <button
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  backgroundColor: 'var(--main-turquoise)',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                }}
                onClick={() => {
                  dispatch(actions.addToCart({ ...dish, isFullPrice }));
                }}
                disabled={!dish.availability}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.1)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 176, 185, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <svg.PlusSvg />
              </button>
            </div>
          )}
        </div>
        
        {/* Sold Out Overlay */}
        {!dish.availability && (
          <div style={{
            textAlign: 'center',
            padding: '12px',
            backgroundColor: '#fee',
            borderRadius: 12,
            marginTop: 12,
          }}>
            <span style={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 14,
              fontWeight: 600,
              color: '#e74c3c',
            }}>
              Currently Unavailable
            </span>
          </div>
        )}
        
        {/* Additional Buttons */}
        {MENU_CONFIG?.isOrderFromAppSupported && (
          <div style={{ marginTop: 12, display: 'flex', gap: 10 }}>
            <components.Button
              text='Reviews'
              colorScheme='secondary'
              onClick={() => {
                navigate(Routes.Reviews);
              }}
              containerStyle={{ flex: 1 }}
            />
          </div>
        )}
      </section>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main className='scrollable' style={{ paddingBottom: 0 }}>
        {renderImage()}
        {renderDetails()}
        {renderPriceAndActions()}
      </main>
    );
  };

  return (
    <div
      id='screen'
      style={{
        opacity,
        backgroundColor: '#F6F9F9',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      {renderHeader()}
      {renderContent()}
    </div>
  );
};
